import SearchEngineMobile from './search/SeachEngineMobile'

const SearchEngine = () :JSX.Element => { 
      return  <SearchEngineMobile /> 
} 

export default SearchEngine